import {createContext} from "react";

export const FilterRelatorioContext = createContext();
